import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotificationService, AppNotification } from '../../../../Service/notification.service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications: AppNotification[] = [];
  private sub?: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.sub = this.notificationService.notifications$
      .subscribe(list => this.notifications = list);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  close(id: number) {
    this.notificationService.dismiss(id);
  }

  pause(n: AppNotification) {
    this.notificationService.pause(n.id);
  }

  resume(n: AppNotification) {
    this.notificationService.resume(n.id);
  }

  icon(n: AppNotification) {
    switch (n.type) {
      case 'success': return 'bi-check-circle';
      case 'error': return 'bi-x-circle';
      case 'warning': return 'bi-exclamation-triangle';
      default: return 'bi-info-circle';
    }
  }

}
